const  router = [
	{
		path: '/yuyue',
		component: () => import('../../../pages/yuyue/index.vue'),
		meta: {title: '预约'},
		name: 'yuyue'
	},
];

export default router